import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button, Icon } from "semantic-ui-react";
import API_BASE_URL from "../../config";
import userEvent from "@testing-library/user-event";

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const Details = ({ resultType, reportUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const filePath = `${process.env.PUBLIC_URL}/pdfs/${resultType.toLowerCase().replace(/\s/g, "")}.pdf`;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setPageNumber((prev) => Math.min(prev + 1, numPages));

  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          marginTop: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <Button onClick={goToPrevPage} disabled={pageNumber === 1}>
          <Icon name="arrow left" /> Geri
        </Button>

        <span>
          Sayfa {pageNumber} / {numPages}
        </span>

        <Button onClick={goToNextPage} disabled={pageNumber === numPages}>
          İleri <Icon name="arrow right" />
        </Button>

        <Button
          as="a"
          href={`${API_BASE_URL}${reportUrl}`}
          download
          icon="download"
          content="Kişisel PDF İndir"
          color="blue"
        />
      </div>
      {/* <Button
    as="a"
    href={filePath}
    target="_blank"
    rel="noopener noreferrer"
    download
    icon="download"
    content="PDF İndir"
    color="teal"
  />
 */}

      <Document
        //file={filePath}
        file={filePath}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div style={{ padding: "2rem" }}>Yükleniyor...</div>}
      >
        <Page
          pageNumber={pageNumber}
          width={Math.min(window.innerWidth * 0.9, 1100)}
        />
      </Document>

      {/* <Document
    file={filePath}
    onLoadSuccess={onDocumentLoadSuccess}
    loading={<div style={{ padding: "2rem" }}>Yükleniyor...</div>}
        >
        <Page pageNumber={pageNumber}   width={Math.min(window.innerWidth * 0.9, 1100)} />
      </Document> */}
    </div>
  );
};

export default Details;
